import { exists, readTextFile, writeTextFile } from "@tauri-apps/plugin-fs";
import { resolvePath } from "@/services/drives";
import { logger } from "@/services/logger";
import type { ConfigRepository } from "./ConfigRepository";

const log = logger.scope("config-repository");
const CONFIG_RELATIVE_PATH = "Config/settings.json";

export const driveConfigRepository: ConfigRepository = {
  async load() {
    try {
      const path = await resolvePath(CONFIG_RELATIVE_PATH);
      if (!(await exists(path))) return null;
      const raw = await readTextFile(path);
      return JSON.parse(raw) as Record<string, unknown>;
    } catch (err) {
      log.warn("Config/settings.json is missing or unreadable; falling back to local settings.", err);
      return null;
    }
  },

  async save(settings) {
    try {
      const path = await resolvePath(CONFIG_RELATIVE_PATH);
      await writeTextFile(path, JSON.stringify(settings, null, 2));
    } catch (err) {
      log.warn("Failed to mirror settings to the active root's Config/ folder.", err);
    }
  },
};
